<template>
  <div>
    <div class="content-area__heading">
      <h2 class="mb-1">{{ teamName }}</h2>
    </div>
    <vx-card>
      <vs-tabs>
        <vs-tab label="Results">
          <div class="tab-text">
            <vs-table
              search
              pagination
              :data="matchups"
              max-items="25"
              description
              :description-items="[25, 50, 100]"
              description-title="Matchups"
              description-connector="of"
              description-body="Pages"
              @selected="goToBoxScore"
            >
              <template slot="header">
                <vs-row>
                  <vs-col vs-w="3" vs-xs="12" vs-sm="12" style="margin: 5px 0;">
                    <h4>Season Matchups</h4>
                  </vs-col>
                </vs-row>
              </template>
              <template slot="thead">
                <vs-th sort-key="hometeam_name">Home Team</vs-th>
                <vs-th sort-key="awayteam_name">Away Team</vs-th>
                <vs-th>Score</vs-th>
                <vs-th sort-key="period">Period</vs-th>
                <vs-th sort-key="period">League</vs-th>
                <vs-th sort-key="court_name">Court</vs-th>
                <vs-th sort-key="division_name">Division</vs-th>
                <vs-th sort-key="game_date">Game Date</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="index" :data="d" v-for="(d, index) in data">
                  <vs-td :data="d.home_team_name">{{ d.hometeam_name }}</vs-td>
                  <vs-td :data="d.away_team_name">{{ d.awayteam_name }}</vs-td>
                  <vs-td
                    :data="
                      `${d.away_team_score || 0} - ${d.home_team_score || 0}`
                    "
                  >
                    {{
                      `${d.away_team_score || 0} - ${d.home_team_score || 0}`
                    }}
                  </vs-td>
                  <vs-td :data="d.period">{{ d.period }} </vs-td>
                  <vs-td :data="d.league_name">{{ d.league_name }} </vs-td>
                  <vs-td :data="d.court_name">{{ d.court_name }}</vs-td>
                  <vs-td :data="d.division_name">{{ d.division_name }}</vs-td>
                  <vs-td :data="d.game_date">{{
                    d.game_date && formatDate(d.game_date)
                  }}</vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vs-tab>
        <vs-tab label="Players">
          <div class="tab-text">
            <vs-table>
              <template slot="thead">
                <vs-th>Email</vs-th>
                <vs-th>Name</vs-th>
                <vs-th>Website</vs-th>
                <vs-th>No.</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].email">
                    {{ data[indextr].email }}
                  </vs-td>
                  <vs-td :data="data[indextr].username">
                    {{ data[indextr].name }}
                  </vs-td>
                  <vs-td :data="data[indextr].id">
                    {{ data[indextr].website }}
                  </vs-td>
                  <vs-td :data="data[indextr].id">
                    {{ data[indextr].id }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vs-tab>
        <vs-tab label="Schedule">
          <div class="tab-text">
            <vs-table noDataText="No Games Found">
              <template slot="thead">
                <vs-th>Date</vs-th>
                <vs-th>Court</vs-th>
                <vs-th>League</vs-th>
                <vs-th>Opponent</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="tr.id" v-for="tr in schedule">
                  <vs-td :data="tr.game_date">
                    {{ dateFormat(Date.parse(tr.game_date)) }}
                  </vs-td>
                  <vs-td :data="tr.court">
                    {{ tr.court }}
                  </vs-td>
                  <vs-td :data="tr.league">
                    {{ tr.league }}
                  </vs-td>
                  <vs-td :data="tr.opponent">
                    {{ tr.opponent }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vs-tab>
      </vs-tabs>
    </vx-card>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { format } from "date-fns";
const dateTimeFormat = new Intl.DateTimeFormat("en", {
  year: "numeric",
  month: "short",
  day: "2-digit"
});

export default {
  name: "Team",
  created() {
    this.loadTeamSchedule();
    this.loadTeamSeason();
  },
  props: ["id"],
  watch: {
    id() {
      this.loadTeamSchedule();
      this.loadTeamSeason();
    }
  },
  data() {
    return {
      games: [],
      matchups: [],
      schedule: [],
      team: {},
      emptyGameTxt: ""
    };
  },
  computed: {
    teamName() {
      return this.team && this.team.name;
    }
  },
  methods: {
    dateFormat(d) {
      return dateTimeFormat.format(d);
    },
    ...mapActions({
      getTeamSeason: "team/getTeamSeason",
      getTeamSchedule: "team/getTeamSeasonSchedule"
    }),
    async loadTeamSeason() {
      if (this.id) {
        this.team = await this.getTeamSeason({ id: this.id });
      }
    },
    async loadTeamSchedule() {
      this.$vs.loading();
      const { json } = await this.getTeamSchedule({ seasonId: this.season });
      this.matchups = json.reverse();
      this.$vs.loading.close();
    },
    formatDate(d) {
      return d && format(new Date(d), "MMM d, yyyy hh:mm a");
    },
    goToBoxScore(d) {
      this.$router.push({ name: "boxscore", params: { id: d.game_id } });
    }
  }
};
</script>
